import React from 'react';
import './style.scss';
import clsx from 'clsx';
import icons from '../../../../common/Icons';
import { RichText, Text } from '@sitecore-jss/sitecore-jss-react';

const BulletPointListing2Item = ({ data, perRow, separatedByDash }) => {
  const { heading, leadingByDash, text } = data.fields;

  const className = clsx(
    'bpl-item',
    `bpl-item-${perRow}`,
    `bpl-item-${separatedByDash ? 'normal' : 'or'}`
  );

  return (
    <div className={className}>
      {!!leadingByDash?.value ? (
        <div className="bpl-item-icon">
          <div />
        </div>
      ) : (
        <img src={icons.circleCheck} className="bpl-item-icon" />
      )}
      <div className="bpl-item-content">
        <div className="bpl-item-content-title">
          <Text field={heading} />
        </div>
        {text && <RichText className="bpl-item-content-desc" field={text} />}
      </div>
    </div>
  );
};

export default BulletPointListing2Item;
